import { Link } from 'react-router-dom';
import type { FC } from 'react';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  category: string;
  cover: string;
  rating: number;
  views: string;
  status: string;
  tags: string[];
  updateTime?: string;
}

const ComicCard: FC<ComicCardProps> = ({
  id,
  title,
  author,
  category,
  cover,
  rating,
  views,
  status,
  tags,
  updateTime,
}) => {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[5/7] w-full overflow-hidden">
          <img
            src={cover}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            width="400"
            height="560"
          />
        </div>
        <div className="absolute top-2 left-2">
          <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-foreground-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="inline-flex items-center gap-1 bg-background-50/90 backdrop-blur-sm px-2 py-0.5 rounded text-xs font-semibold text-accent-500 whitespace-nowrap">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </span>
        </div>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">{author}</p>
        <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
        {updateTime && (
          <p className="text-[11px] text-foreground-400 mt-1.5">{updateTime} 更新</p>
        )}
      </div>
    </Link>
  );
};

export default ComicCard;